module.exports = ".projects {\n  padding-bottom: 350px;\n}\n\n\n.generate-btns-container {\n  margin-top: 20px;\n}\n\n\n.ms-3 {\n  -webkit-margin-start: 1.5rem !important;\n          margin-inline-start: 1.5rem !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment-generator/payment-generator.component.css
// module id = ./src/app/payment-generator/payment-generator.component.css
// module chunks = main